export default "__VITE_ASSET__B0B8CZ1w__"